
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <strong>Competition</strong>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="campaignIsCompetition"
                  label="Competition enabled"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <strong>Meta</strong>
          </v-card-title>
          <v-card-text>
            <ul>
              <li>
                End date:
                <strong>{{
                  campaignEndsAt ? campaignEndsAt.toLocaleString() : "Not set"
                }}</strong>
              </li>
              <li v-if="campaignId" class="campaign-id">
                Campaign ID: <strong>{{ campaignId }}</strong>
              </li>
              <li v-if="campaignCreatedAt">
                Created at: <strong>{{ campaignCreatedAt }}</strong>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class BuilderCampaign extends Vue {
  @Getter campaignId!: number

  get campaignEndsAt (): Date | null {
    return this.$store.getters.campaignEndsAt
  }

  get campaignIsCompetition (): boolean {
    return this.$store.getters.campaignIsCompetition
  }

  set campaignIsCompetition (data: boolean) {
    this.$store.commit('SET_CAMPAIGN_IS_COMPETITION', data)
  }

  get campaignCreatedAt (): string {
    return this.$store.getters.campaignCreatedAt?.toLocaleString() || null
  }
}
</script>

<style scoped></style>
